export function getInitialStateCaucion() {
   return {
      datosCaucion: null,
      saveFile: [],
   };
}

export default getInitialStateCaucion();
